// Todo to review all // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values that have to be added
// with migration to Angular 17
export enum ROUTE_IDS {
  // WIZARD
  RESIDENCE_COUNTRY = 'country',
  AGE = 'age',

  JUNIOR_BASE = 'junior-base',
  JUNIOR_COURSE = 'junior-course',
  JUNIOR_EXTRAS = 'junior-extras',

  ADULT_BASE = 'adult-base',
  ADULT_COURSE = 'adult-course',
  ADULT_EXTRAS = 'adult-extras',
  QUOTE = 'quote',
  ENROLMENT = 'enrolment',
  ENROLMENT_PAYMENT = 'payment',
  ENROLMENT_PAYMENT_CONFIRMATION = 'payment-confirmation',
  REGISTRATION = 'registration',
  DELIVERY = 'delivery',

  ONLINE_BASE = 'online-base',

  // FORM
  FORM_ROOT = '',
  QUOTE_FORM = 'quote-form',
  BOOKING_FORM = 'booking-form',
  SEND_QUOTE_TO_EMAIL = 'email-quote',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  BOOKING_ENROLMENT_PAYMENT = 'payment',
  FLYWIRE_PAYMENT = 'flywire-payment',
  CONFIRMATION = 'confirmation',

  QUOTE_ERROR = 'quote-error',
}
